module.exports = __webpack_public_path__ + "f19daae9292c4257b61404770088716a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/app/images/Remorque_Belle_Voiture_Logo204.png
 ** module id = 452
 ** module chunks = 0
 **/